import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import { AccessTime } from "@mui/icons-material"; // Time icon from Material-UI

const Time = ({ label, value, onChange }) => {
  return (
    <TextField
      label={label}
      variant="standard"
      value={value}
      onChange={onChange ? onChange : undefined} // Conditionally apply onChange
      type="time" // Makes this a time input
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Box sx={{ color: "grey" }}>
              <AccessTime /> {/* Time icon */}
            </Box>
          </InputAdornment>
        ),
      }}
      sx={{
        // Label color
        "& .MuiInputLabel-root": { color: "grey" }, // Default label color
        "& .MuiInputLabel-root.Mui-focused": { color: "grey" }, // Focused label color

        // Underline colors
        "& .MuiInput-underline:before": { borderBottomColor: "grey" }, // Default underline color
        "& .MuiInput-underline:hover:before": { borderBottomColor: "grey" }, // Hover underline color
        "& .MuiInput-underline:after": { borderBottomColor: "grey" }, // Focused underline color
      }}
    />
  );
};

export default Time;
